module.exports = __webpack_public_path__ + "img/NW13.64e7c7ce.gif";